import qs from "qs";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { getOwnerIds } from "../../Utility/ownerUtils";
import { requestHideLoader, requestShowLoader } from "../../Store/Global/action";
import { getStatuses } from "../../Utility/statusUtils";

const ARRAY_SERIALIZER = (params) =>
  qs.stringify(params, { arrayFormat: "repeat" });

export const useSearchExecutor = ({ownerlist = [],myTeam = [],setIsLoading=()=>{},enqueueSnackbar,internationalise,handleValidateCodevalue,}) => {
  const dispatch = useDispatch();

  const buildSearchParams = useCallback((searchState={}) => {
     const { status,selectedOwner, ...rest } = searchState;

    const ownerIds = getOwnerIds(selectedOwner, ownerlist, myTeam);
    const statuses = Array.isArray(status)
    ? getStatuses(status)
    : status;
    return {
      ...rest,
      status : statuses,
      ownerIds,
      pocMobileNumber: searchState?.pocPhone,
      };
    },
    [ownerlist,myTeam,enqueueSnackbar,internationalise,handleValidateCodevalue]
);

  const executeSearch = useCallback( async (action, params) => {
      dispatch(requestShowLoader())

      try {
        await
        dispatch(
            action({
            params,
            paramsSerializer: ARRAY_SERIALIZER,
          })
        );

    } catch (error) {

      console.error("Search execution failed", error);

      } finally {
        dispatch(requestHideLoader())
      }
    },
    [dispatch, setIsLoading]
  );

  return {buildSearchParams,executeSearch};
};
